/**
 * The four lines that touch the real `document` and the real `localStorage`.
 *
 * Everything interesting about applying a theme is in `src/theme.ts`, which
 * takes the element and the storage as arguments and so can be tested without
 * a DOM. This is the other end of that: the one module in the pair that names
 * a global, kept to exactly the two it needs so that the tested part stays the
 * whole part.
 */

import { applyTheme, rememberTheme } from './theme'

/** `localStorage`, or nothing — Safari in private mode throws on the property. */
function safeStorage() {
  try {
    return window.localStorage
  } catch {
    return null
  }
}

/**
 * What the app does when it learns the truth: draw it, and remember it for the
 * next first paint. One call, because doing one without the other is how the
 * attribute on `<html>` and the copy the inline script reads drift apart.
 */
export function showTheme(id: string): void {
  applyTheme(document.documentElement, id)
  rememberTheme(id, safeStorage())
}
